import { Component, OnInit } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { FormPackageComponent } from '../form-package/form-package.component';
import { Observable } from 'rxjs';
import { PackageApiService } from 'src/app/micro-services/packages/package-api.service';
import { EPackageType } from 'src/app/micro-services/packages/enum/e-package-type';
import { Package } from 'src/app/micro-services/packages/models/package';
import { YesNoModalComponent } from 'src/app/components/shared/modals/yes-no-modal/yes-no-modal.component';
import { map } from 'rxjs/operators';
import { PackagePlatformService } from 'src/app/micro-services/packages/services/package-plateform.service';
import { PackageFactory } from 'src/app/micro-services/packages/package-factory';
import { PackageFactoryService } from 'src/app/micro-services/packages/services/package-factory.service';

@Component({
  selector: 'app-list-package',
  templateUrl: './list-package.component.html',
  styleUrls: ['./list-package.component.scss'],
})
export class ListPackageComponent implements OnInit {

  packages$: Observable<Package[]> ;
  save$: Observable<Package[]> ;
  

  constructor(
    private modalCtrl: ModalController,
    private packageFactoryService: PackageFactoryService,
    private toastController: ToastController
  ) { 

  }

  ngOnInit() {
    this.packages$ = this.save$ = this.packageFactoryService.create(EPackageType.Plateform).getPackages(EPackageType.Plateform);
  }
  
  async addPackage(){

    const modalEdition = await this.modalCtrl.create({
      component: FormPackageComponent
    });
    modalEdition.present();

    const { data, role } = await modalEdition.onWillDismiss();
    
    if (role === 'create') {
      if(data){
        this.packages$ = this.packages$.pipe(
          map(
            address => {
              return address;
            }
          )
        )
      }
    }
  }

  async editPackage(pack : Package){

    const modalEdition = await this.modalCtrl.create({
      component: FormPackageComponent,
      componentProps: { package : pack }
    });
    modalEdition.present();

    const { data, role } = await modalEdition.onWillDismiss();
    
    if (role === 'edit') {
      if(data){
        this.packages$ = this.packages$.pipe(
          map(packages => {
            var test = packages.find(address => address.id == data.id)
            test = data;
            return packages;
          })
        )
      }
    }
  }

  async deletePackage(pack : Package){

    const modalEdition = await this.modalCtrl.create({
      component: YesNoModalComponent,
      componentProps : {
        title : "Suppression",
        text : "Confirmation de la suppression ?"
      }
    });
    modalEdition.present();

    const { role } = await modalEdition.onWillDismiss();

    if (role === 'confirm') {
      //delete
      this.packageFactoryService.create(EPackageType.Plateform).deletePackage(pack).subscribe({
        next : (deleteId) => {
          if(deleteId){
            this.packages$ = this.packages$.pipe(
              map(packages => {
                var index = packages.findIndex(address => address.id == deleteId)
                if (index >= 0 ) {
                  packages.splice(index,1);
                }
                return packages;
              })
            )
          }
        },
        error : () => {
          this.toastController.create(
            {
              message: 'Erreur lors de la suppression',
              duration: 1500,
            }
          )
        }
      })
    }
  }
}
